<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin">
          <button class="btn btn-primary commonbutt" type="button" *ngIf="actionmode == 'Edit' &&  roleID == '64' " (click)="deleteUser()" [disabled]="
              invalidMail ||
              showList == true ||
              userEmail ||
              loader
            ">
            <em class="fa fa-trash"></em>&nbsp;Delete
          </button>
          <button class="btn btn-primary commonbutt" type="button" (click)="submitData1()" [disabled]="
              invalidMail ||
              showList == true ||
              nameExist ||
              userFNameMinLength ||
              userFNameExceedLength ||
              userFNameNotAlphabet ||
              userLNameMinLength ||
              userLNameExceedLength ||
              userLNameNotAlphabet ||
              userMobileMinLength ||
              userMobileExceedLength ||
              userMobileNotNumber ||
              userAddressMinLength ||
              userAddressExceedLength ||
              userEmail ||
              invalidMobile ||
              loader
            ">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>
          <button class="btn btn-success commonbutt" type="button" 
            *ngIf="!showList == false && RAC_APROVE == '1'"
            [disabled]="showList == false" data-toggle="modal" data-target="#myModal">
            <em class="fa fa-thumbs-up "></em>&nbsp;&nbsp;
            <span class="bold">Approve</span>
          </button>
          <button class="btn btn-warning commonbutt" type="button" 
            *ngIf="!showList == false && RAC_APROVE == '1'"
            [disabled]="showList == false" data-toggle="modal" data-target="#myModal2">
            <em class="fa fa-thumbs-down"></em> <span class="bold">Reject</span>
          </button>
          <button 
            class="btn btn-danger commonbutt" 
            (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>



    <div class="card-body">
      <!-- row  -->
      <div class="row">
        <div class="col-md-12">
          <!-- form  -->
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 2% 2% 2%">
                  <div>
                    <div>
                      <div *ngIf="loader">
                        <div style="margin-left: 323px;text-align: center;position: absolute;z-index: 1;">
                          <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                        </div>
                      </div>
                      <div class="col-lg-3">
                        <label>First Name</label>
                        <input [(ngModel)]="user_screen_details.USER_FIRSTNAME" [disabled]="showList == true"
                          #USER_FIRSTNAME="ngModel" type="text" placeholder="Enter First Name"
                          class="form-control m-input" id="USER_FIRSTNAME" name="USER_FIRSTNAME"
                          (blur)="checkUserFName($event.target.value)"
                          (input)="checkUserFNameLength($event.target.value)" value="" />
                        <span *ngIf="userFNameExceedLength" style="color: red">Max limit is 50 alphabets.</span>
                        <span *ngIf="userFNameNotAlphabet" style="color: red">Accepts alphabets only.</span>
                        <span *ngIf="userFNameMinLength" style="color: red">Min 1 alphabets required.</span>
                      </div>
                      <div class="col-lg-3">
                        <label>Last Name</label>
                        <input [(ngModel)]="user_screen_details.USER_LASTNAME" [disabled]="showList == true"
                          #USER_LASTNAME="ngModel" type="text" placeholder="Enter Last Name"
                          class="form-control m-input" id="USER_LASTNAME" name="USER_LASTNAME"
                          (blur)="checkUserLName($event.target.value)"
                          (input)="checkUserLNameLength($event.target.value)" value="" />
                        <span *ngIf="userLNameExceedLength" style="color: red">Max limit is 50 alphabets.</span>
                        <span *ngIf="userLNameNotAlphabet" style="color: red">Accepts alphabets only.</span>
                        <span *ngIf="userLNameMinLength" style="color: red">Min 1 alphabets required.</span>
                      </div>
                      <div class="col-lg-3">
                        <label>Email</label>
                        <input [(ngModel)]="user_screen_details.USER_EMAIL" [disabled]="showList == true"
                          #email="ngModel" type="text" placeholder="Enter Email Id"
                          (input)="onbalnkMail($event.target.value)" (blur)="
                            checkEmailNames($event.target.value);
                            checkmail($event.target.value)
                          " name="email" value="" class="form-control m-input" />
                        <span class="errmsg" *ngIf="invalidMail" style="color: red">Invalid email address</span>
                        <span *ngIf="nameExist" style="color: red">
                          Email already exist
                        </span>
                      </div>
                      <!-- <br> -->
                      <div class="clr"></div>
                      <div class="divider"></div>
                      <div class="col-lg-3">
                        <label>Role Name</label>
                        <select id="ROLE_ID" class="form-control" [(ngModel)]="user_screen_details.ROLE_ID">
                          <option disabled value="">Select</option>
                          <option value="{{combo.ROLE_ID}}" *ngFor="let combo of combo_details1">{{ combo.ROLE_NAME }}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Address</label>
                        <input [(ngModel)]="user_screen_details.USER_ADDRESS" #USER_ADDRESS="ngModel"
                          [disabled]="showList == true" type="text" placeholder="Enter Address" id="USER_ADDRESS"
                          name="USER_ADDRESS" value="" class="form-control m-input"
                          (blur)="checkUserAddress($event.target.value)"
                          (input)="checkAddressLength($event.target.value)" />
                        <span *ngIf="userAddressExceedLength" style="color: red">Max limit is 250 char.</span>
                        <span *ngIf="userAddressMinLength" style="color: red">Min limit is 2 char.</span>
                      </div>
                      <div class="col-lg-3">
                        <label>Mobile Number</label>
                        <input maxlength="10" [(ngModel)]="user_screen_details.USER_MOBILE" #USER_MOBILE="ngModel"
                          [disabled]="showList == true" type="text" placeholder="Enter Mobile Number" id="USER_MOBILE"
                          name="USER_MOBILE" value="" class="form-control m-input"
                          (blur)="checkUserMobile($event.target.value)"
                          (input)="checkMobileLength($event.target.value)" />
                        <span *ngIf="userMobileExceedLength" style="color: red">Maximum 10 digits are allowed.</span>
                        <span *ngIf="userMobileNotNumber" style="color: red">Invalid mobile no.</span>
                        <span *ngIf="userMobileMinLength" style="color: red">Please enter valid 10 digit Mobile
                          no.</span>
                        <span *ngIf="invalidMobile && !userMobileNotNumber" style="color: red">
                          Invalid Mobile No
                        </span>
                      </div>
                      <br />
                      <div class="clr"></div>
                      <div class="divider"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- portlet ending  -->
            </div>
          </div>
          <!-- form ending  -->
        </div>
      </div>
      <!-- row ending  -->
    </div>
  </div>
</div>

<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 50px;">
        <button type="button" class="close" data-dismiss="modal"> &times;</button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-up"></span>Approve Request
        </h4>
      </div>
       <!-- modal body  -->
      <div class="modal-body">
        <div class="col-lg-13">
          <label> Remarks</label>
          <textarea 
          [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
          rows="8" cols="20" type="text"
            class="form-control m-input" placeholder="Enter  Remarks">
          </textarea>
          <span 
          *ngIf="aprove_details.APPROVAL_REMARKS == ''" 
          class="m-form__help" style="color: red">Please enter
            Remarks</span>
        </div>
      </div>
      <!-- modal body  -->

       <!-- modal footer  -->
      <div class="modal-footer">
        <button class="btn btn-success " type="button" 
        (click)="aproveReject(1)" data-dismiss="modal">
          <em class="fa fa-check "></em>&nbsp;&nbsp;
          <span class="bold">Approve</span>
        </button>
      </div>
      <!-- modal footer  -->
    </div>
  </div>
</div>
<!-- ########## -->


<!-- ########## -->
<div class="modal fade" id="myModal2" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 50px;">
        <button type="button" class="close" data-dismiss="modal"> &times;</button>
        <h4 class="modal-title"><span class="glyphicon glyphicon-thumbs-down"></span>Reject Request</h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label>Remarks</label>
          <textarea 
          [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
          rows="8" cols="20" type="text"
            class="form-control m-input" placeholder="Enter  Remarks">
          </textarea>
          <span 
          *ngIf="aprove_details.APPROVAL_REMARKS == ''" 
          class="m-form__help" style="color: red">Please enter
            Remarks</span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-warning " type="button"
         (click)="aproveReject(2)" data-dismiss="modal">
          <em class="fa fa-check "></em>&nbsp;&nbsp;
          <span class="bold">Reject</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## -->

<div *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>User Management Search</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" *ngIf="RAC_ADD == '1'" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>
      <button class="btn btn-success commonbutt" type="button" (click)="openfileDialog()">
        <em class="fa fa-upload"></em>&nbsp;&nbsp;
        <span class="bold">Upload</span>
      </button>
      <input type="file" id="fileLoader" (change)="fileChangeListener($event)" name="files" title="Load File"
        style="display: none;" />
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div class="wr15">
                    <div class="instruct">
                      <div class="int1" style="margin-left: 17px">
                        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                        <br />
                        <span class="txt">
                          1. Select at least one value out of First Name,Email

                        </span>
                        <br />
                        <span class="txt">
                          2. You can also use a combination of the given fields to search </span>
                        <br />
                        <span></span>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <label>First Name</label>
                      <input maxlength="50" [(ngModel)]="user_screen_details.USER_FIRSTNAME" type="text"
                        placeholder="Enter First Name" class="form-control m-input"
                        (blur)="checkUserFName1($event.target.value)"
                        (input)="checkUserFNameLength1($event.target.value)" value="" />
                      <span *ngIf="userFNameExceedLength1" style="color: red">Max limit is 50 alphabets.</span>
                      <span *ngIf="userFNameNotAlphabet1" style="color: red">Accepts alphabets only.</span>
                    </div>

                    <div class="col-lg-3">
                      <label class="">Email </label>

                      <input [(ngModel)]="user_screen_details.usr_email_id" placeholder="Enter  Email"
                        (input)="onbalnkMail1($event.target.value)" (blur)="
                        checkEmailNames1($event.target.value);
                        checkmail1($event.target.value)
                      " name="email" value="" class="form-control m-input" />
                      <span class="errmsg" *ngIf="invalidMail1" style="color: red">Invalid email address</span>
                    </div>
                  </div>
                  <div class="btn clear-button button-margin">
                    <button class="btn btn-primary commonbutt" (click)="searchData()" type="button" [disabled]="userFNameExceedLength1 ||
                      userFNameNotAlphabet1 ||
                      invalidMail1">
                      <em class="fa fa-search "></em>&nbsp;Search
                    </button>
                  </div>
                </div>
                <br />
                <div class="errwrap">
                  <div class="errdiv1" id="err"></div>
                </div>

                <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                  <table aria-describedby="userMasterData" class="table table-striped" [mfData]="serachtabledata"
                    [mfRowsOnPage]="5">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 20%" *ngIf="RAC_VIEW == '1' && RAC_EDIT == '1'">
                          Actions
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="status">Status</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="email">FirstName</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="email">EMAIL</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="email">ROLE</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 50%">
                          <mfDefaultSorter by="email">MOBILE NO</mfDefaultSorter>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="
                          let item of (serachtabledata
                            | paginate: { itemsPerPage: 10, currentPage: p })
                        ">
                        <td *ngIf="RAC_VIEW == '1' && RAC_EDIT == '1'">
                          <button class="btn btn-default btn-circle" *ngIf="RAC_VIEW == '1'" type="button"
                            (click)="showFormData(item.USER_ID, 1)">
                            <em class="fa fa-eye"></em>
                          </button>
                          <button class="btn btn-default btn-circle" *ngIf="RAC_EDIT == '1'" [disabled]="item.USER_STATUS != '1'" type="button"
                            (click)="showFormData(item.USER_ID, 2)">
                            <em class="fa fa-pencil"></em>
                          </button>
                        </td>
                        <td>{{ item.USER_STATUS == '1' ? 'ACTIVE' : 'INACTIVE' }}</td>
                        <td>{{ item.USER_FIRSTNAME }}</td>
                        <td>{{ item.USER_EMAIL }}</td>
                        <td>{{ item.ROLE_NAME }}</td>
                        <td>{{ item.USER_MOBILE }}</td>
                      </tr>
                    </tbody>
                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                    <tfoot>
                      <tr>
                        <td colspan="4">
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div *ngIf="loader">
                  <div style="margin:auto; text-align: center">
                    <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="actionmode == 'View'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title" *ngIf="showList == !false">{{ viewTitle }}</h1>
      <h1 class="screen-title" *ngIf="showList == false">
        {{ insertDataTitle }}
      </h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'View'" class="btn back-button button-margin ">
          <button [disabled]="showList == true" *ngIf="!showList == false" [disabled]="showList == !false"
            class="btn btn-primary commonbutt" type="button" (click)="submitdata()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="tdive">
                        <table aria-describedby="userSearchDetails" class="viewtable">
                          <div *ngFor="let q of serachTableInfo">

                            <tr>
                              <th scope="col"><span class="vlbl">Firstname</span></th>
                              <td>
                                <span class="vVal">{{ q.USER_FIRSTNAME }}</span>
                              </td>
                            </tr>

                            <tr>
                              <th scope="col"><span class="vlbl">Lastname</span></th>
                              <td>
                                <span class="vVal">{{ q.USER_LASTNAME }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col"><span class="vlbl">Email</span></th>
                              <td>
                                <span class="vVal"> {{ q.USER_EMAIL }} </span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col"><span class="vlbl">Address</span></th>
                              <td>
                                <span class="vVal"> {{ q.USER_ADDRESS }} </span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col"><span class="vlbl">Mobile No</span></th>
                              <td>
                                <span class="vVal"> {{ q.USER_MOBILE }} </span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col"><span class="vlbl">Role name</span></th>
                              <td>
                                <span class="vVal"> {{ roleName }} </span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col"><span class="vlbl">Status</span></th>
                              <td>
                                <span class="vVal">{{ q.USER_STATUS ==='1' ? 'ACTIVE' : 'INACTIVE' }}</span>
                              </td>
                            </tr>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>